import { makeStyles } from '@mui/styles';
import '@fontsource/metropolis';

const textFieldStyles = makeStyles(theme => ({
  root: {
    '& .MuiInputLabel-root': {
      fontWeight: 'bold',
      fontFamily: 'metropolis',
    },
    '& .MuiOutlinedInput-input': {
      fontFamily: 'metropolis',
    },
  },
}));
export default {
  textFieldStyles,
  loginContainer: {
    height: '100%',
    flexDirection: 'row',
    flex: 1,
  },
  formContainer: {
    flex: 3,
    paddingRight: '5%',
    paddingLeft: '5%',
    paddingTop: '5%',
    justifyContent: 'space-evenly',
  },
  coverImage: {
    flex: 1,
  },
  coverImageContainer: {
    flex: 4,
    flexDirection: 'column',
  },
  appDownloadCaption: {
    textAlign: 'center',
  },
  emailInput: {
    marginBottom: '10%',
    styleOverrides: {
      fontFamily: 'metropolis',
    },
  },
  loginButton: {
    color: '#FFF',
    padding: '2%',
    fontFamily: 'metropolis',
    letterSpacing: '.5rem',
    fontWeight: 'bold',
    backgroundImage: 'linear-gradient(to right, #00984A, #00D467)',
    '&:hover': {
      backgroundColor: '#00984A',
    },
  },
  appDownloadImage: {
    margin: '1%',
  },
};
